import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';

import { FileInputComponent } from './file-input.component';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule,
    MaterialModule
  ],
  exports: [FileInputComponent],
  declarations: [FileInputComponent]
})
export class FileInputModule { }



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/file-input/file-input.module.ts